<template>
    <section class="tables">
        <div class="row">
            <div class="col-lg-12 grid-margin stretch-card">
                <div class="card">
                    <div class="card-body">
                        <h2 class="card-title">{{ $t('names.pageFragments.name') }}</h2>
                        <p class="card-description">{{ $t('names.pageFragments.description') }}</p>
                        <b-table striped hover :items="items" :fields="fields" @row-clicked="editFragment" class="clickable"></b-table>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import axios from 'axios'
    import {Const} from '../../../config'

    export default {
        name: 'FragmentList',
        data() {
            return {
                items: [],
                fields: [
                    {
                        key: 'id',
                        label: 'ID',
                        sortable: true,
                        thStyle: 'width: 75px;'
                    },
                    {
                        key: 'name',
                        label: this.$t('forms.name'),
                        sortable: true
                    },
                    {
                        key: 'key',
                        label: this.$t('forms.key'),
                        sortable: true
                    }
                ]
            }
        },
        mounted() {
            axios.get(Const.API_HOST + '/admin/fragments')
                .then(response => response.data).then(body => {
                this.items = body
            }).catch(error => {
                // eslint-disable-next-line no-console
                console.error(error)
            })
        },
        methods: {
            editFragment(item) {
                this.$router.push('/fragment/edit/' + item.id)
            }
        }
    }
</script>

<style scoped>
    .clickable /deep/ tbody td {
        cursor: pointer;
    }

</style>
